import React, { FC, useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Layout, Affix } from 'antd';
import { showErrorModal, errorData, hideNavBar } from 'apollo/cache';
import NavBar from 'components/generalUI/MainLayout/NavBar';
import Footer from 'components/generalUI/MainLayout/Footer';
import { useHistory } from 'react-router-dom';
import ErrorModal from 'views/Error';
import styles from './MainLayout.module.scss';
import NewsBanner from './NewsBanner';

interface Props {
  children?: JSX.Element;
}

const MainLayout: FC<Props> = ({ children }: Props) => {
  const { Header, Content, Footer: FooterLayout } = Layout;
  const showErrorModalHook = useReactiveVar(showErrorModal);
  const isNavBarHidden = useReactiveVar(hideNavBar);
  const history = useHistory();
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  useEffect(() => {
    if (showErrorModalHook) {
      setErrorModalVisible(true);
    }
  }, [showErrorModalHook]);

  if (window.location.pathname === '/shareLinks') {
    return (
      <div className={styles.App}>
        <div className={styles.ComponentContainer}>{children}</div>
      </div>
    );
  }

  return (
    <Layout>
      <ErrorModal
        visible={errorModalVisible}
        onClose={() => {
          setErrorModalVisible(false);
          showErrorModal(false);
          errorData(null);
          history.push('/');
        }}
      />
      {!isNavBarHidden && (
        <Affix offsetTop={0}>
          <NewsBanner />
          <Header className={styles.LayoutHeader}>
            <NavBar />
          </Header>
        </Affix>
      )}
      <Content>
        <div className={styles.MainContainer}>
          <div className={styles.App}>
            <div className={styles.ComponentContainer}>{children}</div>
          </div>
        </div>
      </Content>
      <FooterLayout className={styles.LayoutFooter}>
        <Footer />
      </FooterLayout>
    </Layout>
  );
};

MainLayout.defaultProps = {
  children: undefined,
};

export default MainLayout;
